export default __webpack_public_path__ + "static/media/chantilly11.ad6cebb6.jpg";